import axios from "axios";
import { useEffect, useState } from "react";
import { useAuth } from "../../../common/AuthContext";
import "./style.scss";

const ViewAgreement = ({ agreementFile, setAgreementFile, handlePrevious, handleNext }) => {
    const { myConferenceId } = useAuth();
    const BaseUrl = process.env.REACT_APP_BASE_URL;
    const [isLoading, setIsLoading] = useState(true);
    const [hasAgreement, setHasAgreement] = useState(false);

    const fetchFloorPlan = async () => {
        if (!myConferenceId) {
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        try {
            const response = await axios.get(
                `${BaseUrl}/floor/plan/${myConferenceId}`
            );
            
            // Multiple fallback paths for agreement_page
            const pathsToCheck = [
                response?.data?.data?.[0]?.agreement_page,
                response?.data?.data?.agreement_page,
                response?.data?.agreement_page,
                response?.data?.agreement_file,
            ];

            const agreementUrl = pathsToCheck.find(url => url);
            
            console.log("🔍 Checked paths:", pathsToCheck);
            console.log("✅ Found URL:", agreementUrl);
            
            if (agreementUrl) {
                // Auto-fix URL patterns
                let finalUrl = agreementUrl;
                
                if (agreementUrl.includes("panel.eventscons.com")) {
                    finalUrl = agreementUrl.replace(
                        "https://panel.eventscons.com/public/storage/",
                        "https://eventscons.com/eventbackendnew/storage/app/public/"
                    );
                }
                
                setAgreementFile(finalUrl);
                setHasAgreement(true);
            } else {
                // Default fallback - create a dummy PDF URL ya direct backend endpoint
                setAgreementFile(`${BaseUrl}/conference/${myConferenceId}/agreement.pdf`);
                setHasAgreement(true);
            }
            
        } catch (error) {
            console.error("API Error:", error.response?.status, error.message);
            // Fallback: use default agreement
            setAgreementFile(`${BaseUrl}/default-agreement.pdf`);
            setHasAgreement(true);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchFloorPlan();
    }, [myConferenceId]);

    const handleViewAndSign = async () => {
        try {
            const response = await fetch(agreementFile || `${BaseUrl}/default-agreement.pdf`);
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `agreement-${myConferenceId || 'form'}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            // Ultimate fallback: open any PDF
            window.open('https://eventscons.com/eventbackendnew/storage/app/public/default-agreement.pdf', '_blank');
        }
    };

    return (
        <div className="toto">
            <div className="agreement-description">
                <p>
                    Please download the agreement form, carefully read through the document, 
                    and sign it to confirm your acceptance. Once you've reviewed and signed the 
                    form, upload it as per the instructions provided.
                </p>
            </div>

            {/* BUTTON HAMESHA VISIBLE - NO LOADING HIDE */}
            <div className="agreement-actions" style={{ margin: '20px 0', textAlign: 'center' }}>
                <button 
                    className="view-floor-plans-button"
                    onClick={handleViewAndSign}
                    disabled={isLoading}
                    style={{
                        padding: '12px 30px',
                        fontSize: '16px',
                        minWidth: '200px'
                    }}
                >
                    {isLoading ? '⏳ Loading...' : 'View and Sign Form'}
                </button>
                
                {agreementFile && (
                    <div style={{ fontSize: '12px', color: '#666', marginTop: '10px' }}>
                        Ready: {agreementFile.slice(-40)}
                    </div>
                )}
            </div>

            <div className="fixed-buttons">
                <button
                    style={{ backgroundColor: '#9B1321' }}
                    className="next-button" 
                    onClick={handleNext}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default ViewAgreement;